import Page from '../../page';

export default class UserLogin extends Page {
}
